import IAbsenceState from './IAbsenceState'

export const initialState: IAbsenceState = {
  isLoading: false,
  error: false,
  list: undefined,
}
